<template>
  <!-- 全局提示框 -->
  <transition name="slide-fade">
    <div v-if="visible" :class="'dialog-tips' + ' dialog-' + type">
      <div><i class="iconfont icon-xiaoxi"></i> {{ message }}</div>
    </div>
  </transition>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      type: "info",
      message: "提示",
    };
  },
};
</script>
<style scoped>
.dialog-tips {
  min-width: 380px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #edf2fc;
  position: fixed;
  left: 50%;
  top: 100px;
  padding: 0.5rem 1rem;
  transform: translateX(-50%);
  background-color: #edf2fc;
  overflow: hidden;
  display: flex;
  z-index: 999;
  align-items: center;
  color: #303133;
}
.dialog-info {
  background-color: #edf2fc;
  border: 1px solid #edf2fc;
  color: #909399;
}
.dialog-success {
  background-color: #f0f9eb;
  border: 1px solid #9cf072;
  color: #67c23a;
}
.dialog-warning {
  background-color: #faecd8;
  border: 1px solid #e6ae5b;
  color: #e6a23c;
}
.dialog-danger {
  background-color: #fde2e2;
  border: 1px solid #f19999;
  color: #f56c6c;
}

.slide-fade-enter,
.slide-fade-leave-to {
  margin-top: -30px;
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-to,
.slide-fade-leave {
  margin-top: 0px;
  opacity: 1;
}
</style>
